/**
   * Devuelve los 4 descriptores de capas EPC que se pasan al worker (CreateEntities)
   * y al backend al guardar el pictograma. Función pura — solo formatea estado.
   *
   * @param {Object} opts
   * @param {Object} opts.totalEntitiesDesign - { pilings, modules, panels } devuelto por el worker
   * @param {number} opts.totalStructures     - count de POLYLINE/LWPOLYLINE del DXF
   * @param {Object} opts.createElements      - { pilings: bool, modules: bool } del modal Configurar
   */
export function getLayerDescriptors({
  totalEntitiesDesign = {},
  totalStructures     = 0,
  createElements      = {},
} = {}) {
  return [
    {
      code: 'pilings', name: 'Hincados', icon: 'band-aid', order: 0,
      quantity: 0,
      total_entities:  totalEntitiesDesign.pilings ?? 0,
      create_entities: !!createElements.pilings,
      in_design: false,
    },
    {
      code: 'structures', name: 'Estructuras', icon: 'stream', order: 1,
      quantity:        totalStructures,
      total_entities:  totalStructures,
      create_entities: true,
      in_design: true,
    },
    {
      code: 'modules', name: 'Modulos', icon: 'solar-panel', order: 2,
      quantity: 0,
      total_entities:  totalEntitiesDesign.modules ?? 0,
      create_entities: !!createElements.modules,
      in_design: false,
    },
    {
      code: 'panels', name: 'Paneles', icon: null, order: 3,
      quantity: 0,
      total_entities:  totalEntitiesDesign.panels ?? 0,
      create_entities: false,
      in_design: false,
    },
  ]
}
